import React from "react";
import { Link } from "react-router-dom";

// The site's one bold interaction: a rubber-stamp press. Hover fills with
// stamp ink; press sinks the button a pixel like a stamp meeting paper.
const base =
    "group relative inline-flex items-center justify-center border-[1.5px] border-stamp px-6 py-3 " +
    "font-plex-mono text-[13px] font-medium uppercase tracking-[0.18em] text-stamp " +
    "transition-[background-color,color,transform] duration-200 ease-out " +
    "hover:bg-stamp hover:text-paper active:translate-y-px active:scale-[0.97] " +
    "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-stamp";

function StampButton({ to, onClick, children, className = "" }) {
    const inner = (
        <>
            {/* Inner keyline, like the double border on an approval stamp */}
            <span aria-hidden="true" className="pointer-events-none absolute inset-[3px] border border-stamp/40 group-hover:border-paper/40 transition-colors" />
            <span className="relative">{children}</span>
        </>
    );
    if (to) {
        return <Link to={to} className={`${base} ${className}`}>{inner}</Link>;
    }
    return <button type="button" onClick={onClick} className={`${base} ${className}`}>{inner}</button>;
}

export default StampButton;
